import React from 'react';
import Navbar from './Navbar'; // ✅ same folder → use "./"

export default function Common() {
  return (
    <div>
      <Navbar />
    </div>
  );
}
